import React from 'react';

export const LandingContext = React.createContext({});

LandingContext.displayName = 'LandingContext';
